export class ValueOf {
    get value() {
        return this._value;
    }
    setValue(value) {
        this._value = value;
    }
}
export function valueOf() {
    return new ValueOf();
}
